export const ROUTES_LIST_CONST = 'APP_ROUTES';
export const RESOURCES_LIST_CONST = 'RESOURCES_LIST';
export const APP_AUTH_RESOURCE_CONST = 'APP_AUTH_RESOURCE';
export const ALL_RESOURCES_LIST_CONST = 'ALL_RESOURCES_LIST';
export const ROUTES_VIEWS_CONST = 'ROUTES_VIEWS';
export const ALL_LIBRARIES_LIST_CONST = 'LIBRARIES_LIST';
